import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const RoundedButton = ({ children, ...props }) => {
  const BootstrapButton = styled(Button)({
    boxShadow: 'none',
    width: '100%',
    height: '48px',
    color: 'white',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    borderRadius: 50,
    lineHeight: 1.5,
    backgroundColor: '#0A0A0A',
    borderColor: '#0A0A0A',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#0A0A0A',
      borderColor: '#0A0A0A',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0A0A0A',
      borderColor: '#005cbf',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });

  return (
    <BootstrapButton {...props} type='submit'>
      {children}
    </BootstrapButton>
  );
};

export default RoundedButton;
